import React from 'react';
import { IconProps } from './types';

export const CancelledIcon: React.FC<IconProps> = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        className={className}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.3327 7.99984C13.3327 10.9454 10.9449 13.3332 7.99935 13.3332C5.05383 13.3332 2.66602 10.9454 2.66602 7.99984C2.66602 5.05432 5.05383 2.6665 7.99935 2.6665C10.9449 2.6665 13.3327 5.05432 13.3327 7.99984ZM5.68166 11.2603L11.2598 5.68215C11.0004 5.3178 10.6814 4.9988 10.317 4.73934L4.73885 10.3175C4.99831 10.6819 5.31731 11.0009 5.68166 11.2603Z"
            fill="#261B36"
        />
    </svg>
);
